import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from 'providers/AuthProvider'
import { ROUTES } from './routes'

const PublicRoute = () => {
  const { getAuthRouteContent } = useAuth()

  return getAuthRouteContent(
    <Navigate to={ROUTES.DASHBOARD} replace />,
    <Outlet />
  )
}

export default PublicRoute
